import {
    APPTOOLBAR_BASIC_RESET_APP_STATE,
    APPTOOLBAR_RESET_APP_STATE, DRAWINGTOOLBAR_CLEAR_RULERS_ON_SCREEN,
    DRAWINGTOOLBAR_MEASURETOOL_EDIT,
    DRAWINGTOOLBAR_MEASURETOOL_LOADED, DRAWINGTOOLBAR_MOUSECLICMEASURE,
    MEASURETOOL_END_MEASURING,
    MEASURETOOL_START_MEASURING, MULTIBED_RESET_APP_STATE,
} from "../lib/types";

const initialState = {
    active: false,
    points: [],
    mouseClickMeasure: false
};

export default ( state = initialState, action ) => {
    let points;
    /* discriminate the action type */
    switch (action.type) {
        case MEASURETOOL_START_MEASURING:
            /* create new points array */
            points = [];
            /* add initial point */
            points.push(action.payload.x, action.payload.y);

            return {
                ...state,
                points: points
            };

        case MEASURETOOL_END_MEASURING:
            /* make a copy of the points */
            points = state.points.slice();
            /* add initial point */
            points.push(action.payload.x, action.payload.y);

            return {
                ...state,
                points: points
            };

        case DRAWINGTOOLBAR_MEASURETOOL_EDIT:
            /* create new points array */
            points = [];
            return {
                ...state,
                points: points,
                active: action.payload
            };

        case DRAWINGTOOLBAR_MOUSECLICMEASURE:
            return {
                ...state,
                mouseClickMeasure: action.payload
            };

        case DRAWINGTOOLBAR_CLEAR_RULERS_ON_SCREEN:
            return initialState;

        case DRAWINGTOOLBAR_MEASURETOOL_LOADED:
            return initialState;

        case APPTOOLBAR_BASIC_RESET_APP_STATE:
        case MULTIBED_RESET_APP_STATE:
        case APPTOOLBAR_RESET_APP_STATE:
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/measuretool-reducer.js